const baseFinancialColumns = [
  { key: 'date', label: 'Date' },
  { key: 'reference', label: 'Reference #' },
  { key: 'totalItems', label: 'Total Items' },
  { key: 'goodsExVatOther', label: 'Goods Ex VAT - Other' },
  { key: 'vatOther', label: 'VAT - Other' },
  { key: 'goodsExVat20', label: '20% Goods Ex VAT' },
  { key: 'vat20', label: '20% VAT' },
  { key: 'goods0', label: '0% Goods' },
  { key: 'totalGoods', label: 'Total Goods' },
  { key: 'totalVat', label: 'Total VAT' },
  { key: 'total', label: 'Total' },
];

const loyaltyColumns = [
  { key: 'invoiceDate', label: 'Date' },
  { key: 'invoiceNo', label: 'Credit Number' },
  { key: 'totalVat', label: 'Total VAT' },
  { key: 'invoiceTotal', label: 'Total' },
];

const statementColumns = [
  { key: 'date', label: 'Date' },
  { key: 'statementNumber', label: 'Statement #' },
  { key: 'totalInvoicesThisWeek', label: 'Total Invoices This Week' },
];

export const columnsMap = {
  invoices: baseFinancialColumns,
  creditNotes: baseFinancialColumns,
  rebates: baseFinancialColumns,
  loyalty: loyaltyColumns,
  statements: statementColumns,
};
